// extracted by mini-css-extract-plugin
module.exports = {"outer":"MegamiSlotButton_outer_JjN2z","inner":"MegamiSlotButton_inner_1_NQe"};